module.exports = __webpack_public_path__ + "img/dht22.3ea54ddf.jpg";